/* eslint-disable radix */
import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';

const ComapnyAuthGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated && user === null) {
    return <Redirect to="/login" />;
  }
  else if (isAuthenticated && user?.userType === "superAdmin") {
    return <Redirect to="/dashboard" />;
  }
  else if (isAuthenticated && user?.userType === "member") {
    // Members have no dashboard route — bounce to login.
    return <Redirect to="/login" />;
  }

  return (
    <>
      {children}
    </>
  );
};

ComapnyAuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ComapnyAuthGuard;
